import { lastEventId } from '@sentry/react'

import { posthog } from './posthog'
import { getRecentApiErrors } from './recent-api-errors'
import { api } from '@/lib/api/client'

// One in-app "Báo lỗi" submission. The Sentry feedback widget already stores
// the message + screenshot; this payload is the extra trace context that goes
// to the dev Telegram chat so an admin can start investigating immediately.
export interface SupportReportPayload {
    message: string
    route: string
    app_version?: string
    recent_req_ids?: string[]
    replay_url?: string
    sentry_event_id?: string
}

export function buildSupportReportPayload(
    message: string,
): SupportReportPayload {
    const payload: SupportReportPayload = {
        message,
        route: window.location.pathname,
    }

    const version = window.__APP_VERSION__?.version
    if (version) {
        payload.app_version = version
    }

    const reqIds = getRecentApiErrors()
        .map((e) => e.requestId)
        .filter((id): id is string => Boolean(id))
    if (reqIds.length > 0) {
        payload.recent_req_ids = reqIds
    }

    try {
        const replayUrl = posthog.get_session_replay_url?.()
        if (replayUrl) {
            payload.replay_url = replayUrl
        }
    } catch {
        // Replay URL is a nice-to-have; never block the report on it.
    }

    const eventId = lastEventId()
    if (eventId) {
        payload.sentry_event_id = eventId
    }

    return payload
}

// Fire-and-forget: the feedback already lives in Sentry, so a failed Telegram
// notification only costs immediacy, never the report itself.
export async function sendSupportReport(message: string): Promise<void> {
    try {
        await api.post('/support-reports', buildSupportReportPayload(message))
    } catch (err) {
        console.warn('[support-report] failed to notify dev chat', err)
    }
}
